import {getUserConfig} from "@utility/utils";

const initialState = {
    list: [],
    total: 0,
    loading: false,
    submitting: false,
    searchParams: {
        refresh: false,
        status_tag: 0,
        adminID: "",
        start_date: "",
        end_date: "",
        page: 1,
        count: 30,
        ...getUserConfig("updateData")
    }
}

const update = (state = initialState, action) => {
    switch (action.type) {
        case 'UPDATE_DATA':
            return {
                ...state,
                ...action.payload
            }
        case 'UPDATE_DATA_RELOAD':
            return {
                ...state,
                searchParams: {
                    ...state.searchParams,
                    refresh: true
                }
            }
        case 'UPDATE_DATA_INIT':
            return {
                ...initialState,
                searchParams: {
                    ...initialState.searchParams,
                    ...getUserConfig("updateData")
                }
            }
        default:
            return {...state};
    }
}

export default update
